module.exports = new __parcel__URL__("MondaySelectBoardIllustrationSpork.1ee5dca4.svg").toString();